import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { LogIn, ArrowLeft, ShieldCheck } from "lucide-react";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center px-6">
      <div className="glow-bg" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="relative z-10 w-full max-w-md bg-black/60 backdrop-blur-xl border border-white/10 p-10"
        data-testid="login-card"
      >
        <Link to="/" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-wider text-white/50 hover:text-glow-primary mb-10">
          <ArrowLeft className="w-4 h-4" /> Gallery
        </Link>

        <div className="flex items-center gap-3 mb-2">
          <ShieldCheck className="w-6 h-6 text-glow-primary" />
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-glow-primary">Restricted</span>
        </div>
        <h1 className="font-heading font-900 text-3xl tracking-tighter text-white">Admin Access</h1>
        <p className="font-mono text-sm text-white/50 mt-4 leading-relaxed">
          Sign in with Google to manage the collectibles vault — upload, edit and curate the collection.
        </p>

        <Button
          onClick={handleLogin}
          className="w-full mt-10 bg-glow-primary text-black font-bold hover:bg-glow-primary/80 rounded-none font-mono text-sm uppercase tracking-wider h-12 shadow-[0_0_24px_rgba(0,240,255,0.3)]"
          data-testid="google-login-btn"
        >
          <LogIn className="w-4 h-4 mr-2" /> Continue with Google
        </Button>
      </motion.div>
    </div>
  );
}
